import React from 'react'
import { clearMessage } from '../../actions/message'
import { useDispatch, useSelector } from 'react-redux'

export default function GetToaster() {
    const dispatch = useDispatch()
    const { toastMessage, toastMessageType } = useSelector(state => state.message)

    return (
        <div className={`${!toastMessageType ? "errorToasterHolder" : ""} successToastHolder`}>
            {toastMessageType ?
                <img src="/assets/img/successToast.svg" alt="" />
                :
                <img src="/assets/img/errorToast.svg" alt="" />
            }
            <div className="contentHolder">
                <p className="header">{toastMessage}</p>
                {/* <p>A verification email has been resent. Please check your inbox and follow the instructions to verify your email.</p> */}
            </div>
            <img onClick={() => dispatch(clearMessage())} className="closeIcon" src="/assets/img/x-close.svg" alt="" />
        </div>
    )
}
